import Vue from 'vue';

import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-CN';

import router from './router/index.js';
import RouteConfig from './router/config';
import store from './store/index.js';

import { showProfile } from './utils/auth';
import { encodeRedirect } from './utils/redirect';

import * as filters from './filters';
import BaseList from './components';
import App from './App.vue';

// 修复移动端兼容 BUG：el-select 单选 + filterable（如办理课卡页的"所属学员"搜索下拉）时，
// Element UI 2.10.1 的 readonly 计算属性为
//   `!filterable || multiple || (!isIE() && !isEdge() && !visible)`
// 即下拉未展开时输入框带 readonly。移动端浏览器在输入框获得焦点的瞬间检测到 readonly 就不会弹出键盘，
// 导致手机端无法输入文字搜索学员（桌面端不受影响）。
// 去掉 `(!isIE() && !isEdge() && !visible)` 条件、仅保留 filterable/multiple 约束，
// 与 Element UI 后续版本行为一致；多选与非可搜索下拉的 readonly 行为保持不变。
ElementUI.Select.computed.readonly = function () {
  return !this.filterable || this.multiple;
};
Vue.use(ElementUI, { locale });
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]));
Object.values(BaseList).forEach((v) => Vue.use(v));

const initUser = showProfile();
if (initUser.id) {
  store.commit('user/SET_PROFILE', initUser);
}

router.beforeEach((to, from, next) => {
  if (from.path && from.path !== to.path) {
    router.lastRoute = from;
  }

  if (to.path === RouteConfig.login.path || to.path === RouteConfig.onboard.path || store.getters.userId) {
    return next();
  }

  const user = showProfile();
  if (user.id) {
    store.commit('user/SET_PROFILE', user);
    return next();
  } else {
    // 未登录：把目标页面固化进 redirect 参数，登录成功后跳回。
    // 手机端微信/企微会经整页 OAuth 跳转，组件内存不可靠，必须依赖 URL 参数。
    return next({
      name: RouteConfig.login.name,
      query: { redirect: encodeRedirect(to.path, to.query) },
    });
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
